import { useApp } from "../context/AppContext";
import { startGoogleLogin } from "../context/AuthContext";

/* Brand-styled "Continue with Google" (Emergent-managed Google Auth) */
export default function GoogleButton({ portal = "farmer", testId = "google-login-button" }) {
  const { t } = useApp();
  return (
    <>
      <div className="auth-or"><span>{t("auth.or")}</span></div>
      <button type="button" className="google-btn" onClick={() => startGoogleLogin(portal)} data-testid={testId}>
        <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
          <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9.1 3.5l6.8-6.8C35.8 2.4 30.3 0 24 0 14.6 0 6.5 5.4 2.6 13.3l7.9 6.1C12.4 13.5 17.7 9.5 24 9.5z" />
          <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v8.5h12.7c-.6 3-2.3 5.5-4.8 7.2l7.5 5.8c4.4-4.1 7.1-10.1 7.1-17z" />
          <path fill="#FBBC05" d="M10.5 28.6A14.6 14.6 0 0 1 9.5 24c0-1.6.3-3.2.8-4.6l-7.9-6.1A24 24 0 0 0 0 24c0 3.9.9 7.5 2.6 10.7l7.9-6.1z" />
          <path fill="#34A853" d="M24 48c6.3 0 11.7-2.1 15.6-5.7l-7.5-5.8c-2.1 1.4-4.8 2.3-8.1 2.3-6.3 0-11.6-4-13.5-9.7l-7.9 6.1C6.5 42.6 14.6 48 24 48z" />
        </svg>
        <span>{t("auth.google")}</span>
      </button>
    </>
  );
}
